import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './failed.component.html',
  styleUrls: ['./failed.component.css']
})
export class FailedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
